export default "__VITE_ASSET__Cdu$VkTK__"